import {
	requestGet,
	requestPost,
	requestPut,
	requestDelete,
} from "../utils/dva16";

import {
	NLogin,
	NFreeReport,
	EGet,
	EGetOne,
	EPost,
	EPut,
	RSetState,
	EDelete,
} from "./contants";

const FreeReport = {
	namespace: NFreeReport,
	state: {
		reportDetailData: null,
		reportPage: null,
		loading: false,
	},
	reducers: {
		[RSetState](state, { payload }) {
			return {
				...state,
				...payload,
			};
		},
	},
	effects: {
		async [EGet]({ payload, callback }, { call, reducer, select, effect }) {
			reducer(RSetState, { loading: true });
			let res = await requestGet("reports", payload);
			reducer(RSetState, { reportPage: res, loading: false });
		},
		async [EGetOne]({ payload, callback }, { call, reducer, select, effect }) {
			reducer(RSetState, { loading: true });
			let res = await requestGet(`reports/${payload?.id}`, payload);
			reducer(RSetState, { reportDetailData: res, loading: false });
		},

		async [EPost]({ payload, callback }, { call, reducer, select, effect }) {
			await requestPost("reports", payload);
			callback && callback();
		},
		async [EPut]({ payload, callback }, { call, reducer, select, effect }) {
			await requestPut(`reports/${payload?.id}`, payload);
			callback && callback();
		},
		async [EDelete]({ payload, callback }, { call, reducer, select, effect }) {
			await requestDelete(`reports/${payload?.id}`, payload);
			callback && callback();
		},
	},
};
export default FreeReport;
